import { useState, useCallback, useMemo } from 'react';
import util from '../utils/utils';
import { useRequest } from 'ahooks';
import { createSearchFast } from '../axios/api';
import moment from 'moment';
import { MOMENT_FOREVER_DAYS } from '../constants';
import { POLICY_EMPTY_FILTERED_TAGS } from '@constants';

function useCreateSearchFast(props) {
  const { manual, onSearchComplete } = props;
  const [searchIndex, setSearchIndex] = useState('');
  const [queryArgs, setQueryArgs] = useState({
    theme_id: "",
    search_content: "",
    order_by: "comprehensive", //relevance,time，comprehensive
    search_type: util.getStorage('research_copilot_policy_search_type') ? util.getStorage('research_copilot_policy_search_type') : 'AI', //ai ,speed
    page_num: 1,
    page_size: 10,
    no_record: false,
    search_index: '',
    state_grid_related: false,
    filter_tags: POLICY_EMPTY_FILTERED_TAGS
  });

  const { loading, data, run } = useRequest(
    async () => {
      try {
        // 如果有do_not_save_search标识，确保不发送任何可能触发搜索记录保存的参数
        const paramsToSend = queryArgs?.do_not_save_search
          ? { ...queryArgs, no_record: true, save_search_history: false }
          : { ...queryArgs };

        const resp = await createSearchFast(paramsToSend);
        if (!queryArgs?.no_record) {
          // Call the callback function if provided, otherwise scroll to top
          if (onSearchComplete) {
            onSearchComplete();
          } else {
            //滚到页面最顶部
            window.scrollTo(0, 0);
          }
        }
        setSearchIndex(resp?.data?.search_index);
        return resp?.data;
      } catch (error) {
        console.log(error);
        return [];
      }
    },
    {
      refreshDeps: [queryArgs],
      debounceWait: 10,
      ready: !manual || queryArgs?.no_record
    }
  );

  const setQuery = (params) => {
    setQueryArgs((oldValues) => {
      let newValues = { ...params };
      newValues.page_num =
        (params?.order_by || params?.page_size || params?.search_type || params?.search_content || params?.filter_tags) ? 1 :
        (params?.page_num ?? 1);

      newValues.search_index =
        (params?.search_type || params?.search_content || params?.filter_tags) ? '' :
        (params?.order_by || params?.page_size || params?.page_num != 1 ? searchIndex : '');

      return {
        ...oldValues,
        ...newValues,
      };
    });
  };

  const refresh = () => {
    run();
  };

  return {
    loading,
    data: data?.policy_item_list ?? [],
    statisticsData: data?.info_statistics,
    allData: data,
    refresh,
    setQuery,
    queryArgs, // 新增：返回当前查询参数
  };
}

export default useCreateSearchFast; 